module.exports = __webpack_public_path__ + "static/img/title1@2x.5226479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/title1@2x.png
// module id = Is04
// module chunks = 70